module.exports = __webpack_public_path__ + "img/tag_icon.e53116c7.svg";